module.exports = __webpack_public_path__ + "yogalogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yogalogo.png
// module id = 911
// module chunks = 0